import axios from 'axios';
import { API_URL } from '../constants';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

export function getSharedRentals(params) {
  return axios({ method: 'get', url: `${API_URL}/shared_rentals`, params: params || {} });
}

export function showSharedRental(id) {
  return axios({ method: 'get', url: `${API_URL}/shared_rentals/${id}` });
}

export function createSharedRental(data) {
  return axios({ method: 'post', url: `${API_URL}/shared_rentals`, data: { shared_rental: data } });
}

export function updateSharedRental(id, data) {
  return axios({ method: 'put', url: `${API_URL}/shared_rentals/${id}`, data: { shared_rental: data } });
}

export function deleteSharedRental(id) {
  return axios({ method: 'delete', url: `${API_URL}/shared_rentals/${id}` });
}

/** Admin: assign vendor (partner) to this shared rental. Only when team is formed. */
export function assignPartnerToSharedRental(id, data) {
  return axios({ method: 'patch', url: `${API_URL}/shared_rentals/${id}/assign_vendor`, params: data });
}

/** Admin: clear vendor assignment when vendor has not confirmed. Lets you assign a different vendor. */
export function unassignPartnerFromSharedRental(id) {
  return axios({ method: 'put', url: `${API_URL}/shared_rentals/${id}/unassign_vendor` });
}

/** Partner: list shared rentals assigned to me. */
export function getMySharedRentals(params) {
  return axios({ method: 'get', url: `${API_URL}/shared_rentals/my`, params: params || {} });
}

/** Partner: mark this shared rental assignment as complete (informational only). */
export function markCompleteSharedRental(id) {
  return axios({ method: 'put', url: `${API_URL}/shared_rentals/${id}/mark_complete` });
}

/** Admin: mark assignment complete for payout (creates credit, shows in Balance Due). */
export function adminMarkCompleteSharedRental(id) {
  return axios({ method: 'put', url: `${API_URL}/shared_rentals/${id}/admin_mark_complete` });
}

/** Admin: count of shared rentals needing action (group formed + vendor not assigned or rest not fully paid). */
export function getSharedRentalsNeedingActionCount() {
  return axios({ method: 'get', url: `${API_URL}/shared_rentals/needing_action_count` });
}

/** Admin: approve vendor listing. */
export function approveSharedRental(id) {
  return axios({ method: 'put', url: `${API_URL}/shared_rentals/${id}/approve` });
}

/** Admin: reject vendor listing (rejection_reason required). */
export function rejectSharedRental(id, rejectionReason) {
  return axios({ method: 'put', url: `${API_URL}/shared_rentals/${id}/reject`, data: { rejection_reason: rejectionReason } });
}

/** Stop only this batch from creating next (auto_create_next = false). Admin or vendor owner. */
export function stopBatchSharedRental(id) {
  return axios({ method: 'put', url: `${API_URL}/shared_rentals/${id}/stop_batch` });
}

/** Stop entire series (all future batches). Admin or vendor owner. */
export function stopSeriesSharedRental(id) {
  return axios({ method: 'put', url: `${API_URL}/shared_rentals/${id}/stop_series` });
}
